<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import clientInfoModal from './clientInfoModalContent.vue'

export default {
  name: 'clientInfoButtonAndModal',
  components: {
    clientInfoModal
  },
  props: ['clientid','clientname', 'contactfirstname', 'contactlastname', "contactmail", "logo" , 'type', 'routesubmit'],
  data() {
    return {
      showModal: false,
      typeicone: "",
      classicone: "",
      buttonTxt:"",
      title:"",
    }
  },
  mounted() {
    //affectation des valeurs en fonction du type de boutton
    if(this.type == "new") {
      this.classicone = "buttonOriginal d-inline";
      this.typeicone = "glyphicon glyphicon-plus";
      this.buttonTxt = trans.get('common.new');
      this.title=trans.get('common.add')
    } else {
      this.classicone = "info-button";
      this.typeicone = "glyphicon glyphicon-info-sign";
      this.title=trans.get('common.infocustomer');
    }
  },
  methods: {
    afficheModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<template>
  <div>
    <div class="row ml-3 d-inline">                                  
      <a id="show-modal" :class="this.classicone" aria-label="right Align" :title="this.title" @click="afficheModal">                 
          <span :class="this.typeicone" aria-hidden="true" :title="this.title"></span>
          <label class="ml-3" for="show-modal"><h6>{{this.buttonTxt}}</h6></label>
      </a> 
    </div>
    <div>
      <clientInfoModal v-if="showModal" @close="closeModal" :clientid="this.clientid" :clientname="this.clientname" :contactfirstname="this.contactfirstname" :contactlastname="this.contactlastname"  :contactmail="this.contactmail" :logo="this.logo" :routesubmit="this.routesubmit"></clientInfoModal>
    </div>
    <!-- use the modal component, pass in the prop -->
  </div>
</template>